export default {
    layout: {
        AnswerStyling: {
            type: `object`,
            default: {},
            children: {
                FontFamilyPublicName: {
                    type: `string`,
                    default: `Open Sans`
                },
                FontSize: {
                    type: `number`,
                    default: 16,
                    min: 5,
                    max: 60
                },
                IsWebSafeFont: {
                    type: `boolean`,
                    default: false
                },
                Color: {
                    type: `color`,
                    default: `#454848`,
                    dontShowError: true
                }
            }
        },
        BackButtonBackGroundColor: {
            type: `color`,
            default: `#ffffff`,
            dontShowError: true
        },
        BackButtonStyling: {
            type: `object`,
            default: {},
            children: {
                FontFamilyPublicName: {
                    type: `string`,
                    default: `Arial`,
                    dontShowError: true
                },
                FontSize: {
                    type: `number`,
                    default: 16,
                    min: 5,
                    max: 60,
                },
                Color: {
                    type: `color`,
                    default: `#454848`,
                    dontShowError: true
                }
            }
        },
        BackButtonText: {
            type: `string`,
            default: ``,
            dontShowError: true
        },
        BackgroundColor: {
            type: `color`,
            default: `#ffffff`,
            dontShowError: true
        },
        BackgroundImageFill: {
            type: `boolean`,
            default: false
        },
        HeaderImagePath: {
            type: `string`,
            dontShowError: true
        },
        BackgroundImagePath: {
            type: `string`,
            dontShowError: true
        },    
        DescriptionStyling: {
            type: `object`,
            default: {},
            children: {
                FontFamilyPublicName: {
                    type: `string`,
                    default: `Open Sans`
                },
                FontSize: {
                    type: `number`,
                    default: 14,
                    min: 5,
                    max: 60,
                    dontShowError: true
                },
                IsWebSafeFont: {
                    type: `boolean`,
                    default: false,
                    dontShowError: true
                },
                Color: {
                    type: `color`,
                    default: `#454848`,
                    dontShowError: true
                }
            }
        },
        EncouragementColor: {
            type: `color`,
            default: `#3b3b3b`,
            dontShowError: true
        },
        HeaderAlignmentPublicName: {
            type: `string`,
            default: `Center`
        },
        LayoutWidth: {
            type: `string`,
            default: `Default`,
            dontShowError: true
        },
        NextButtonBackGroundColor: {
            type: `color`,
            default: `#454848`,
            dontShowError: true
        },
        NextButtonStyling: {
            type: `object`,
            default: {},
            children: {
                FontFamilyPublicName: {
                    type: `string`,
                    default: `Arial`,
                    dontShowError: true
                },
                FontSize: {
                    type: `number`,
                    default: 16,
                    min: 5,
                    max: 60,
                },
                Color: {
                    type: `color`,
                    default: `#454848`,
                    dontShowError: true
                }
            }
        },
        NextButtonText: {
            type: `string`,
            default: ``,
            dontShowError: true
        },
        PageStyling: {
            type: `object`,
            default: {},
            children: {
                FontFamilyPublicName: {
                    type: `string`,
                    default: `Open Sans`
                },
                IsWebSafeFont: {
                    type: `boolean`,
                    default: false
                }
            }
        },
        ProgressBar: {
            type: `object`,
            default: {},
            children: {
                CheckColor: {
                    type: `color`,
                    default: `#88dc3f`,
                    dontShowError: true
                },
                ProgressBarColor: {
                    type: `color`,
                    default: `#e41775`,
                    dontShowError: true
                },
                PercentageColor: {
                    type: `color`,
                    default: `#fff`,
                    dontShowError: true
                },
            }
        },
        QuestionStyling: {
            type: `object`,
            default: {},
            children: {
                FontFamilyPublicName: {
                    type: `string`,
                    default: `Open Sans`
                },
                FontSize: {
                    type: `number`,
                    default: 19,
                    min: 5,
                    max: 60,
                    dontShowError: true
                },
                IsWebSafeFont: {
                    type: `boolean`,
                    default: false
                },
                Color: {
                    type: `color`,
                    default: `#454848`,
                    dontShowError: true
                }
            }
        },
        PageTitle: {
            type: `string`,
            default: `Survey`,
            dontShowError: true
        },
        QuestionColor: {
            type: `object`,
            default: `#e41775`,
            dontShowError: true
        },
        RemovePoweredBy: {
            type: `boolean`,
            default: false
        },
        ShowEncouragementText: {
            type: `boolean`,
            default: false
        },
        HideRequiredFieldsText: {
            type: `boolean`,
            default: false
        },
        TextAlignmentPublicName: {
            type: `string`,
            default: `Center`
        }
    },


    getLoginMethod: {
        action: {
            type: `string`
        },
        authenticationUrl: {
            type: `string`
        },
        culture: {
            type: `string`
        },
        loginCode2Label: {
            type: `string`
        },
        loginType: {
            type: `string`
        },
        layoutSettings: {
            type: `object`,
            default: {}
        },
        welcomeText: {
            type: `string`
        },
        actionObject: {
            type: `object`
        }
    },

    
    navigateToOtherPage: {
        action: {
            type: `string`
        },
        culture: {
            type: `string`
        },
        pageId: {
            type: `guid`
        },
        respondentId: {
            type: `guid`
        },
        sessionId: {
            type: `guid`
        },
        surveyId: {
            type: `guid`
        },
        token: {
            type: `string`
        },
        actionObject: {
            type: `object`,
            children: {
                previousButtonState: {
                    type: `string`
                },
                timeOfPageLoad: {
                    type: `string`
                }
            }
        }
    },


    preview: {
        action: {
            type: `string`
        },
        pageId: {
            type: `guid`
        },
        respondentId: {
            type: `guid`
        },
        sessionId: {
            type: `guid`
        },
        surveyId: {
            type: `guid`
        },
        actionObject: {
            type: `object`,
            children: {
                layoutSettings: {
                    type: `object`
                },
                language: {
                    type: `string`
                }
            }
        }
    },


    loadFeedbackPage: {
        action: {
            type: `string`
        },
        respondentId: {
            type: `guid`
        },
        surveyId: {
            type: `guid`
        },
        culture: {
            type: `string`
        },
        actionObject: {
            type: `object`,
            children: {
                layoutSettings: {
                    type: `object`
                },
                canUnsubScribe: {
                    type: `boolean`,
                    default: false
                },
                messageTypes: {
                    type: `object`
                }
            }
        }
    },


    login: {
        action: {
            type: `string`
        },
        token: {
            type: `string`
        },
        culture: {
            type: `string`
        },
        pageId: {
            type: `guid`
        },
        respondentId: {
            type: `guid`
        },
        sessionId: {
            type: `guid`
        },
        surveyId: {
            type: `guid`
        },
        actionObject: {
            type: `object`
        }
    },


    unsupportedPage: {
        culture: {
            type: `string`
        },
        queueLink: {
            type: `string`
        }
    },


    changeLanguage: {
        action: {
            type: `string`
        },
        actionObject: {
            type: `object`,
            default: {}
        },
        culture: {
            type: `string`
        },
        layoutSettings: {
            type: `object`,
            default: {}
        },
        pageId: {
            type: `guid`
        },
        respondentId: {
            type: `guid`
        },
        sessionId: {
            type: `guid`
        },
        surveyId: {
            type: `guid`
        },
        token: {
            type: `string`
        }
    },


    questionActionObject: {
        pageId: {
            type: `guid`
        },
        respondentId: {
            type: `guid`
        },
        sessionId: {
            type: `guid`
        },
        surveyId: {
            type: `guid`
        },
        token: {
            type: `string`
        }, 
        PreviousButtonState: {
            type: `string`,
        },
        progress: {
            type: `number`,
            min: 0,
            max: 100
        },
        questions: {
            type: `array`
        },
        timeOfPageLoad: {
            type: `string`
        },
        countdownGoSettings: {
            type: `object`,
            default: {},
            children: {
                displayValue: {
                    type: `string`,
                    default: `Off`
                },
                countdownSeconds: {
                    type: `number`,
                    default: -1
                },
                automaticNextQuestion: {
                    type: `boolean`,
                    default: true
                },
                countdownType: {
                    type: `number`,
                    default: 0
                }
            }
        }
    },


    question: {
        descriptionAbove: {
            type: `string`,
            default: ``
        },
        descriptionBelow: {
            type: `string`,
            default: ``
        },
        isDeadEnd: {
            type: `boolean`,
            default: false
        },
        id: {
            type: `guid`
        },
        dummyText: {
            type: `string`,
            default: ``
        },
        labelsNextToControl: {
            type: `boolean`,
            default: false
        },
        isFrozen: {
            type: `boolean`,
            default: false
        },
        HideRequiredFieldsText: {
            type: `Boolean`
        },
        media: {
            type: `array`
        },
        number: {
            type: `number`,
            min: 1
        },
        settings: {
            type: `object`
        },
        text: {
            type: `string`
        },
        type: {
            type: `string`
        }, 
        validation: {
            type: `object`
        },
        displayType: {
            type: `string`
        },
        answersHorizontal: {
            type: `boolean`,
            default: false
        },
        subQuestionsHorizontal: {
            type: `boolean`,
            default: false
        },
        answerColor: {
            type: `color`,
            default: `#fff`
        },
        subQuestionColor: {
            type: `color`,
            default: `#fff`
        },
        showTextBox: {
            type: `boolean`,
            default: true
        },
        maxUploadsPerAnswer: {
            type: `number`,
            min: 0,
            max: 5
        },
        hasSpeechToText: {
			type: 'boolean',
			default: false
		}
    },


    answer: {
        colNumber: {
            type: `number`,
            min: 1
        },
        description: {
            type: `string`,
            default: ``
        },
        htmlInputType: {
            type: `string`
        },
        id: {
            type: `guid`
        },
        isChecked: {
            type: `boolean`
        },
        isExclusive: {
            type: `boolean`,
            default: false
        },
        isOpen: {
            type: `boolean`,
            default: false
        },
        label: {
            type: `string`
        },
        media: {
            type: `array`
        },
        number: {
            type: `number`,
            min: 1
        },
        openField: {
            type: `string`
        },
        type: {
            type: `string`
        },
        validation: {
            type: `object`
        },
        answerAreas: {
            type: `object`
        },
        userText: {
            type: `string`
        },
        percentX: {
            type: `number`,
            min: 0,
            max: 100
        },
        percentY: {
            type: `number`,
            min: 0,
            max: 100
        }
    },


    validation: {
        maxLength: {
            type: `number`
        },
        maxValue: {
            type: `number`
        },
        minValue: {
            type: `number`
        },
        required: {
            type: `boolean`
        },
        validationType: {
            type: `string`
        },
        requiredPoints: {
            type: `number`,
            dontShowError: true,
            min: 1,
            max: 2147483647
        },
        numberScale: {
            type: `number`,
            dontShowError: true,
            min: 0,
            max: 5
        }
    },

    
    media: {
        alignment: {
            type: `string`,
            default: `Top`
        },
        alt: {
            type: `string`,
            default: ``
        },
        mediaType: {
            type: `string`
        },
        url: {
            type: `string`
        }
    },


    questionSettings: {
        autoNext: {
            type: `boolean`,
            default: false
        },
        desktopColumnCount: {
            type: `number`,
            default: 1,
            min: 1, 
            max: 12
        },
        hideRadioButtons: {
            type: `boolean`,
            default: false
        },
        skip: {
            type: `boolean`,
            default: false
        },
        ratingOptionsCount: {
            type: `number`,
            min: 2,
            max: 12
        },
        showAsCircle: {
            type: `boolean`
        },
        showLabels: {
            type: `boolean`
        }
    }
};